module.exports = __webpack_public_path__ + "img/ic.0ffbff27.svg";